import { Link } from 'react-router-dom';
import { useSeoMeta } from '@unhead/react';
import { Home, User } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { EditProfileForm } from '@/components/EditProfileForm';
import { LoginArea } from '@/components/auth/LoginArea';
import { useCurrentUser } from '@/hooks/useCurrentUser';

export default function Profile() {
  const { user } = useCurrentUser();

  useSeoMeta({ title: 'Profile - Zenstr' });

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border/50">
        <div className="container mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-2xl">🧘‍♀️</span>
            <span className="font-display font-semibold">Zenstr</span>
          </div>
          <Link to="/">
            <Button variant="ghost" size="sm"><Home className="w-4 h-4 mr-2" /> Dashboard</Button>
          </Link>
        </div>
      </header>

      <main className="container mx-auto px-6 py-16 max-w-2xl">
        <div className="space-y-8">
          <div className="text-center space-y-2">
            <User className="w-16 h-16 mx-auto text-primary" />
            <h1 className="text-4xl md:text-5xl font-display font-bold">Profile</h1>
          </div>

          {!user ? (
            <Card className="p-12 text-center space-y-4 bg-card/50">
              <p className="text-muted-foreground">Log in to edit profile</p>
              <LoginArea className="max-w-60 mx-auto" />
            </Card>
          ) : (
            <Card className="p-6 bg-card/50">
              <EditProfileForm />
            </Card>
          )}
        </div>
      </main>
    </div>
  );
}
